import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { ThemeProvider } from './theme/ThemeProvider'
import ErrorBoundary from './components/common/ErrorBoundary'

// Initialize MSW if mock data is enabled
async function enableMocking() {
  if (import.meta.env.VITE_USE_MOCK_DATA === 'true') {
    try {
      const { startMocking } = await import('./mocks/browser')
      await startMocking()
    } catch {
      // MSW initialization failed - continue without mocking
    }
  }
}

// Render the app function
function renderApp() {
  const rootElement = document.getElementById('root');

  if (!rootElement) {
    return;
  }

  const root = createRoot(rootElement as HTMLElement);

  root.render(
    <StrictMode>
      <ErrorBoundary>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </ErrorBoundary>
    </StrictMode>,
  )
}

// Initialize MSW first, then render the app
// This ensures MSW is fully ready before any API calls are made
enableMocking()
  .then(() => {
    // Add a small delay to ensure service worker is fully registered
    return new Promise(resolve => setTimeout(resolve, 100));
  })
  .then(() => {
    renderApp();
  })
  .catch(() => {
    // Still try to render the app even if MSW fails
    renderApp();
  });
